import { useState, useEffect, useMemo } from 'react';
import withAuth from '../../../auth';
import Pagination from '../../Pagination';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Imagesdata } from '../../../utils/imageData.js';
import { handleApiRequest } from '../../../utils/apiHandler.js';
import api from '../../../services/axios.js';
import DraggableDriverCard from './drivers/DraggableDriverCard.js';
import DriverCardContent from './drivers/DriverCardContent.js';
import DriverFilters from './drivers/DriverFilters.js';

const DriverList = ({ drivers, setDrivers }) => {
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    fetchDrivers();
  }, [currentPage]);

  const fetchDrivers = async (newFilters = null) => {
    setLoading(true);

    await handleApiRequest({
      requestFn: () =>
        api.post('/manager/drivers', {
          page: currentPage,
          ...(newFilters || filters),
        }),

      onSuccess: ({ data, last_page }) => {
        setDrivers(data);
        setTotalPages(last_page);
      },

      finallyFn: () => {
        setLoading(false);
      },
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFilterChange = (e, column) => {
    const newFilters = {
      ...filters,
      [column]: e.target.value,
    };

    const nonEmptyFilters = Object.keys(newFilters).reduce((acc, key) => {
      if (newFilters[key]) {
        acc[key] = newFilters[key];
      }
      return acc;
    }, {});

    setFilters(nonEmptyFilters);
  };
  const handleSearchSubmit = () => {
    setCurrentPage(1); // reset pagination when filter
    fetchDrivers();
  };

  const approvedDrivers = useMemo(
    () =>
      drivers.filter(
        (driver) =>
          driver.admin_approved &&
          driver.truck_types &&
          driver.truck_types.length > 0,
      ),
    [drivers],
  );

  return (
    <div className="card p-2">
      <div className="d-flex justify-content-center align-items-center ">
        <h3 className="fw-bold mb-1">List of drivers</h3>
        <OverlayTrigger
          trigger="click"
          placement="top"
          container={document.body}
          rootClose
          overlay={
            <Popover
              className="popover custom-popover"
              style={{ zIndex: 1000 }}
            >
              <Popover.Body className="custom-popover-body">
                <div className="text-muted small">
                  Only approved drivers with assigned vehicle are visible
                </div>
              </Popover.Body>
            </Popover>
          }
        >
          <img
            width={22}
            style={{
              cursor: 'pointer',
              marginLeft: '20px',
              position: 'absolute',
              top: '6px',
              right: '6px',
            }}
            src={Imagesdata('info')}
            alt="info"
          />
        </OverlayTrigger>
      </div>

      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: '70vh' }}
        >
          <div className="spinner-border text-primary" role="status" />
        </div>
      ) : (
        <div
          style={{
            flexShrink: 0,
            background: '#fff',
            borderBottom: '1px solid #eee',
            paddingBottom: '12px',
            zIndex: 10,
          }}
        >
          {/* FILTER SIDEBAR */}
          <DriverFilters
            filters={filters}
            handleFilterChange={handleFilterChange}
            handleSearchSubmit={handleSearchSubmit}
          />

          {/* DRIVERS */}
          <div
            style={{
              flex: 1,
              overflowY: 'auto',
              marginTop: '12px',
              paddingRight: '6px',
              height: '62vh',
            }}
          >
            <div className="d-flex flex-column gap-3">
              {approvedDrivers.map((driver) => (
                <DraggableDriverCard key={driver.id} driver={driver}>
                  <div className="card h-100 border-0 driver-card">
                    <DriverCardContent driver={driver} />
                  </div>
                </DraggableDriverCard>
              ))}
            </div>
          </div>

          {/* PAGINATION */}
          {totalPages > 1 && currentPage <= totalPages && (
            <div className="mt-2">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default withAuth(DriverList);
